import React from 'react'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import StateStorage from 'lib/state-storage'
import CommonLayout from 'components/layout/common'
import { isAuthCookiesAvailable } from 'lib/utils/handle-response'
import { withI18next } from 'lib/i18n/withI18next'
import { ENDPOINTS } from 'lib/api/const'
import { request } from 'lib/api'
import PomeloCaresMobile from 'components/pomelo-cares'
import { hasLocizeTranslation } from 'lib/utils/locize'
import DesktopContent from 'components/pomelo-cares/desktop-content'
import styles from './styles.scss'
import BasePage from '../base'

class PomeloCares extends BasePage {
  static async getInitialProps({
    device,
    isServer,
    req,
    res,
    segment_anonymous_id: segmentAnonymousID,
    store,
    user_uid: userUID,
  }) {
    let isThankYouPage = false

    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })

      if (req.url.includes('/thankyou')) {
        isThankYouPage = true
      }

      const { isPhone } = store.getState().device

      // Only phone version has data
      if (isPhone && !isThankYouPage) {
        const { zone: shop, lang } = req.params
        const auth = StateStorage.getCookie('auth')
        const isGuestMode = !isAuthCookiesAvailable(auth)

        try {
          const contents = await request({
            url: ENDPOINTS.pomeloCares.link,
            shop,
            lang,
            includeServerTime: true,
            isGuestMode,
            userUID,
            segmentAnonymousID,
            device,
            ...(Boolean(auth?.token) && { token: auth.token }),
          })

          if (contents.server_time) {
            const TIME_WORK_FROM_HOME_STARTED = 'Wed, 18 Mar 2020 02:00:00 GMT'
            const diffTimeFormatted = dayjs
              .utc(
                dayjs(contents.server_time).diff(TIME_WORK_FROM_HOME_STARTED),
              )
              .format('HH mm ss')
            const day = dayjs(contents.server_time)
              .diff(dayjs(TIME_WORK_FROM_HOME_STARTED), 'day')
              .toString()

            const [hour, minute, second] = diffTimeFormatted.split(' ')

            contents.initial_time = {
              day,
              hour,
              minute,
              second,
            }
          }

          return { contents }
        } catch (e) {
          // Silently exit
        }
      }
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)

      if (window.location.href.includes('/thankyou')) {
        isThankYouPage = true
      }
    }

    return {
      isThankYouPage,
    }
  }

  render() {
    const {
      contents,
      internationalization: { country, language },
      isPhone,
      isThankYouPage,
      t,
    } = this.props
    const meta = {
      title: 'Pomelo Cares',
      description: hasLocizeTranslation(
        t,
        'POMELO_CARE_META_DESC',
        `Pomelo Cares. Join POMELO Fashion as we give back to our community.
      ✓Free Returns ✓Weekly New Arrivals ✓Free delivery ✓Try Now, Pay Later`,
      ),
    }

    return (
      <CommonLayout meta={meta} noSidePadding style={{ marginBottom: '-50px' }}>
        <style jsx>{styles}</style>
        {isPhone ? (
          <PomeloCaresMobile
            contents={contents}
            country={country}
            isThankYouPage={isThankYouPage}
            language={language}
            t={t}
          />
        ) : (
          <DesktopContent
            country={country}
            isThankYouPage={isThankYouPage}
            language={language}
            t={t}
          />
        )}
      </CommonLayout>
    )
  }
}

PomeloCares.propTypes = {
  contents: PropTypes.shape({
    masks: PropTypes.number,
    hospitals: PropTypes.number,
    paypal_money_raised: PropTypes.string,
    masks_money_raised: PropTypes.string,
    server_time: PropTypes.string,
    initial_time: PropTypes.shape({
      day: PropTypes.string,
      hour: PropTypes.string,
      minute: PropTypes.string,
      second: PropTypes.string,
    }),
  }),
  internationalization: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
  isThankYouPage: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

PomeloCares.defaultProps = {
  contents: null,
  isThankYouPage: false,
}

const Extended = withI18next(['global'])(PomeloCares)

export default connect((state) => ({
  internationalization: state.internationalization,
  isPhone: state.device.isPhone,
}))(Extended)
